import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function JoinPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    const destination = token
      ? `/activate-account?token=${encodeURIComponent(token)}`
      : '/activate-account';
    navigate(destination, { replace: true });
  }, [navigate, token]);

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center p-4">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-[#FF6600] animate-spin mx-auto mb-2" />
        <p className="text-[#A1A1AA] text-sm">Redirecting to activation...</p>
      </div>
    </div>
  );
}
